const initialState = {
  siderCollapsed: null,
};

const ui = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SIDER_COLLAPSED": {
      return { ...state, siderCollapsed: action.payload };
    }
    default:
      return state;
  }
};

export default ui;
